// src/.tsx
import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { getFilters } from '@/api/jobExplorer';
import { AuthContext } from "./AuthContext";

const defaultSelected = {
  categories:   [],
  qualities:    [],
  interests:    [],
  study_levels: [],
};

const FiltersCtx = createContext({
  filters: null,
  setFilters: () => {},
  resetFilters: () => {},
  selectedFilters: defaultSelected,
  setSelectedFilters: () => {},
});

export const useFilters = () => useContext(FiltersCtx);


export function FiltersProvider({ children }) {
  const { user } = useContext(AuthContext);
  const [filters, setFilters] = useState(null);

  const [selectedFilters, setSelectedFilters] = useState(() => {
    if (typeof window === 'undefined') return defaultSelected;
    try {
      const stored = localStorage.getItem('selectedFilters');
      return stored ? (JSON.parse(stored)) : defaultSelected;
    } catch {
      return defaultSelected;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('selectedFilters', JSON.stringify(selectedFilters));
    } catch {
    }
  }, [selectedFilters]);

  const resetFilters = () => {
    setFilters(null)
    setSelectedFilters(defaultSelected)
  }
  useEffect(() => {
    if ( !user?.id ){
      resetFilters();
    } else {
      let cancelled = false;
      getFilters().then(data => { if (!cancelled) setFilters(data); });
      return () => { cancelled = true; };
    }
  }, [user?.id]);


  const value = useMemo(
    () => ({ filters, setFilters, selectedFilters, setSelectedFilters }),
    [filters, selectedFilters]
  );

  return <FiltersCtx.Provider value={value}>{children}</FiltersCtx.Provider>;
}
